import { Crown } from "frontend/icons/icons";
import PadInline from "../components/pad-inline";
import { ScrollWithFade } from "../components/scroll-with-fade";
import myStyle from "../cim-sub-menu.module.css";
import classNames from "classnames";
import { getPathPrefix } from "utils/getPathPrefix";
import { useMemo } from "react";
import styles from "../components/components.module.css";
import templatesSubMenuStyles from "./templates-sub-menu.module.css";

/*
      Templates to present first, name, id
                            prod		dev
      flowchart: 	  			  1351
      Flowing mind map      2709
      Cross functional flowchart 215/940
      Critical path         281
      monday Gantt Chart 		2849
      Prioritization Matrix 335
      Store floor Plan, 		332
      Sales account planning  334
    */
const PRODUCTION_IDS = [1351, 2709, 215, 281, 2849, 335, 332, 334];

function overrideTemplates(templates: any[]) {
  return templates.map((template) => {
    if (template.id === "1351") {
      return {
        ...template,
        thumbnailImageURL: getPathPrefix("/images/cim/flowchart.png"),
        previewImageURL: getPathPrefix("/images/cim/flowchart.png"),
      };
    }
    if (template.id === "2709") {
      return {
        ...template,
        thumbnailImageURL: getPathPrefix("/images/cim/mindmap.png"),
        previewImageURL: getPathPrefix("/images/cim/mindmap.png"),
      };
    }
    if (template.id === "281") {
      return {
        ...template,
        thumbnailImageURL: getPathPrefix("/images/cim/critical-path.png"),
        previewImageURL: getPathPrefix("/images/cim/critical-path.png"),
      };
    }
    if (template.id === "215" || template.id === "940") {
      return {
        ...template,
        thumbnailImageURL: getPathPrefix("/images/cim/cross-functunal.png"),
        previewImageURL: getPathPrefix("/images/cim/cross-functunal.png"),
      };
    }
    return template;
  });
}

function getTemplateToShow(templates: any[]) {
  let templatesToShow = [];
  // find and insert the templates chosen by us
  for (const template of templates) {
    const index = PRODUCTION_IDS.indexOf(Number.parseInt(template.id));
    if (index != -1) {
      templatesToShow[index] = template;
    }
  }
  // remove entries we didn't find
  templatesToShow = templatesToShow.filter(Boolean);
  // add templates from the list's start to fill for 16 entries
  for (const template of templates) {
    if (templatesToShow.length >= 16) {
      break;
    }
    const index = PRODUCTION_IDS.indexOf(Number.parseInt(template.id));
    if (index == -1) {
      templatesToShow.push(template);
    }
  }

  return overrideTemplates(templatesToShow);
}

export default function TemplatesSubMenu({
  templates,
  onClick,
}: {
  templates: undefined | any[];
  onClick: (template: any) => void;
}) {
  const templatesToShow = useMemo(() => (templates ? getTemplateToShow(templates) : null), [templates]);

  if (!templatesToShow) return null;

  return (
    <>
      <PadInline>
        <header className={styles.headerStyle}>Templates</header>
        <div className={styles.subHeadingStyle} style={{ paddingRight: "4px" }}>
          Boost creativity and get started faster
          <a className={myStyle.link} style={{ float: "right" }} href="#show=templateLibrary">
            Show all
          </a>
        </div>
      </PadInline>
      <ScrollWithFade>
        {templatesToShow.map((template) => (
          <TemplateCard template={template} key={template.id} onClick={() => onClick(template)} />
        ))}
      </ScrollWithFade>
    </>
  );
}

function TemplateCard({
  template,
  onClick,
}: {
  template: {
    name: string;
    upgradeRequired: boolean;
    thumbnailImageURL: string;
    downloadsCount: number;
  };
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className={classNames(myStyle.card, myStyle.buttonReset, templatesSubMenuStyles.templatesSubMenuButton)}
    >
      <div className={classNames(myStyle.thumbnail, templatesSubMenuStyles.thumbnail)}>
        <img
          alt={template.name}
          src={template.thumbnailImageURL}
          width="100%"
          height="100%"
          className={templatesSubMenuStyles.templateImage}
        />
      </div>
      <div className={templatesSubMenuStyles.templateName}>
        <div className={templatesSubMenuStyles.templateContainer} title={template.name}>
          {template.upgradeRequired && <Crown height={14} />}
          <span className={templatesSubMenuStyles.templateText}>{template.name}</span>
        </div>
      </div>
    </button>
  );
}
